import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { FlaggedStudiesCountQuery, FlaggedStudiesCountQueryVariables } from '@/shared/api';
import FLAGGED_STUDIES_COUNT_QUERY from '../queries/flaggedStudiesCount';

/**
 * Loads how many flagged studies match the filter, feeding the flagged tab badge. Runs FLAGGED_STUDIES_COUNT_QUERY and throws the first GraphQL error message when flaggedStudiesCount is nil.
 *
 * @param filter - Filter criteria forwarded to the GraphQL query.
 * @returns The flagged studies count.
 */
const fetchFlaggedStudiesCount = async (
  filter: FlaggedStudiesCountQueryVariables['filter'],
): Promise<FlaggedStudiesCountQuery['flaggedStudiesCount']> => {
  const client = createClient();
  const flaggedStudiesCountResult = await client.query<
    FlaggedStudiesCountQuery,
    FlaggedStudiesCountQueryVariables
  >({
    query: FLAGGED_STUDIES_COUNT_QUERY,
    variables: {
      filter,
    },
  });
  const { data, errors } = flaggedStudiesCountResult;
  const { flaggedStudiesCount } = data;
  if (_.isNil(flaggedStudiesCount) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return flaggedStudiesCount;
};

export default fetchFlaggedStudiesCount;
